import axios from "axios";

const serverUrl = "https://webapi.startupp.cloud/access/WebAPI/";

const authorize = async (context) => {
  return new Promise((resolve, reject) => {
    const sParams = {
      requestKey: "4d3d57e1-1d9b-4f4b-9f64-16574f211c27",
      action: "authorize",
    };

    try {
      if (!context.AUTH_CODE) {
        axios
          .post(serverUrl, sParams)
          .then((response) => {
            if (response) {
              context.AUTH_CODE = response.data.authorization;
              resolve(context.AUTH_CODE);
            }
          })
          .catch((error) => {
            context.AUTH_CODE = "";
            reject(context.AUTH_CODE);
          });
      } else {
        resolve(context.AUTH_CODE);
      }
    } catch (err) {
      context.AUTH_CODE = "";
      reject(context.AUTH_CODE);
    }
  });
};

export const query = async (obj, fields, filter, context) => {
  try {
    const AUTH_CODE = await authorize(context); // Requests an authorization code before making actual calls

    const sParams = {
      requestKey: "4d3d57e1-1d9b-4f4b-9f64-16574f211c27",
      requestCode: AUTH_CODE,
      action: "sf-search",
      search: [
        {
          sobject: obj,
          fields: fields,
          filter: filter,
        },
      ],
    };

    const { data } = await axios.post(serverUrl, sParams);

    const response = data;
    return response[obj];
  } catch (err) {
    return null;
  }
};

export const rest = async (name, svcName, action, requestKeys, context) => {
  try {
    const AUTH_CODE = await authorize(context); // Requests an authorization code before making actual calls

    const b = {
      Request: action,
      ...requestKeys,
    };

    const sParams = {
      requestKey: "4d3d57e1-1d9b-4f4b-9f64-16574f211c27",
      requestCode: AUTH_CODE,
      action: "sf-rest",
      rest: [
        {
          actionName: name,
          serviceName: svcName,
          body: JSON.stringify(b),
        },
      ],
    };

    const { data } = await axios.post(serverUrl, sParams);
    return JSON.parse(data[name]);
  } catch (err) {
    console.log(err);
    return null;
  }
};
